import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public isSidebarOpenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSidebarOpen$ = this.isSidebarOpenSubject.asObservable();
  constructor() { }

   toggleSidebar(flag) { 
      this.isSidebarOpenSubject.next(flag);
  }
}
